module.exports = __webpack_public_path__ + "img/gu.7872722e.svg";